import React from 'react';
import { MapPin } from 'lucide-react';
import { aboutData } from '../data/mockData';

const About = () => {
  return (
    <section id="about" className="section-padding bg-[#111111]">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="image-hover">
            <div className="aspect-[4/5] overflow-hidden border border-[#c9a962]/20">
              <img 
                src={aboutData.image}
                alt={aboutData.name}
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          
          {/* Content */}
          <div>
            <span className="inline-block text-sm font-medium text-[#c9a962] tracking-wider uppercase mb-4">
              About Me
            </span>
            
            <h2 className="heading-1 text-white mb-4">
              {aboutData.name}
            </h2>
            
            <div className="flex items-center gap-2 text-[#b3b3b3] mb-8">
              <MapPin size={16} className="text-[#c9a962]" />
              <span className="body-regular">{aboutData.location}</span>
            </div>
            
            <div className="space-y-4">
              {aboutData.bio.map((paragraph, index) => (
                <p key={index} className="body-large text-[#b3b3b3]">
                  {paragraph}
                </p>
              ))}
            </div>
            
            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-10 pt-10 border-t border-[#2a2a2a]">
              <div>
                <span className="block text-2xl md:text-3xl font-medium text-[#c9a962]">2+</span>
                <span className="body-small text-[#808080]">Years Experience</span>
              </div>
              <div>
                <span className="block text-2xl md:text-3xl font-medium text-[#c9a962]">50+</span>
                <span className="body-small text-[#808080]">Projects Completed</span>
              </div>
              <div>
                <span className="block text-2xl md:text-3xl font-medium text-[#c9a962]">30+</span>
                <span className="body-small text-[#808080]">Happy Clients</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
